import { createSelector } from '@reduxjs/toolkit';
import { getAuthAccount } from '@/shared/auth/selectors';
import type { WiwState } from '@/store';

export const getAccountSettings = (state: WiwState) => {
  const account = getAuthAccount(state);
  return account.settings;
};

export const getAccountScheduleSettings = createSelector([getAccountSettings], settings => settings.schedule);

export const getAccountBillingSettings = createSelector([getAccountSettings], settings => settings.billing || {});

export const getAccountWorkChatSettings = createSelector([getAccountSettings], settings => settings.workchat || {});
